
export enum PageMode {
  SUBMIT = "submit",
  CHANGE = "change",
  APPROVAL = "approval",
}

export enum OrderStatusRadioOption {
  APPROVED = "approved",
  REQUEST_CHANGE = "request_change",
}

export enum UpfrontPayment {
  NONE = 'NONE',
  INVOICE = 'INVOICE',
  DEPOSIT = 'DEPOSIT',
}

export const ATTRIBUTES = [
  "Quantities",
  "Size Breakdowns",
  "Product Sizes",
  "Imprint Colors",
  "Decoration Methods",
  "Artwork (including spelling)",
];

